import React, { useCallback } from 'react'
import { useUpdateLog } from 'utils/log'

import { FormTitleProps } from '../items/FormTitle'
import RadioLine, { RadioLineProps } from '../items/RadioLine'
import BaseGroup from './BaseGroup'

/**
 * 対象がRadioGroupProps型かチェックする
 * @param target チェック対象
 */
export const isRadioGroupProps = (target: any): target is RadioGroupProps => {
  return target.radios !== undefined && target.title !== undefined
}

/**
 * ラジオグループ
 */
const RadioGroup: React.FC<RadioGroupProps> = (props) => {
  const selectRadio = useCallback(
    (index: number): void => {
      const state = [...props.radios]
      state.forEach((radio) => (radio.isSelected = false))
      state[index].isSelected = true
      props.setRadios && props.setRadios(state)
    },
    [props]
  )

  useUpdateLog(
    props.title,
    {
      title: props.title,
      isRequired: props.isRequired,
      radios: props.radios,
    },
    [props]
  )

  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      {props.radios.map((radio, index) => (
        <RadioLine
          {...radio}
          key={index}
          onClick={(): void => {
            selectRadio(index)
          }}
        />
      ))}
    </BaseGroup>
  )
}

export type RadioGroupProps = FormTitleProps & {
  radios: Array<RadioLineProps>
  formName: string
  setRadios?: (radios: Array<RadioLineProps>) => void
}

export default React.memo<RadioGroupProps>(RadioGroup)
